import {IpcMainInvokeEvent} from "electron";
import getMainBrowserWindow from "../DependencyInjection/mainBrowserWindow";
import getEventDispatcher from "../DependencyInjection/eventDispatcher";
import {PartialDownloadController, PartialDownloadProgress} from "../../../types/downloadManager";

const mainWindow = getMainBrowserWindow();
const eventDispatcher = getEventDispatcher();

export interface PartialProgressStrategy {
    isValid(progress: PartialDownloadProgress): boolean;

    onProgress(progress: PartialDownloadProgress): void;
}

export class UpdatePartialProgressStrategy implements PartialProgressStrategy {
    public isValid(progress: PartialDownloadProgress): boolean {
        return true;
    }

    public async onProgress(progress: PartialDownloadProgress): Promise<void> {
        mainWindow.setProgressBar(progress.percentage);
        await eventDispatcher.dispatch('PartialDownloadProgress', progress);
    }
}

export class SlowPartialProgressStrategy implements PartialProgressStrategy {
    public isValid(progress: PartialDownloadProgress): boolean {
        return 0 === progress.speedBytes
            && 100 !== progress.progress
    }

    public onProgress(progress: PartialDownloadProgress): void {
        console.warn('Slowdown detected while processing: ', progress.fileName, progress);
    }
}

export class StarPartialProgressStrategy implements PartialProgressStrategy {
    public constructor(private controller: PartialDownloadController) {}

    public isValid(progress: PartialDownloadProgress): boolean {
        return 0 === progress.progress;
    }

    public onProgress(progress: PartialDownloadProgress): void {
        eventDispatcher.addHandler('PauseDownloadManager',
            (event: IpcMainInvokeEvent, content: null) => {
                this.controller.pause();
            }
        );

        eventDispatcher.addHandler('ResumeDownloadManager',
            (event: IpcMainInvokeEvent, content: null) => {
                this.controller.resume();
            }
        );

        eventDispatcher.addHandler('CancelDownloadManager',
            (event: IpcMainInvokeEvent, content: null) => {
                this.controller.cancel();
            }
        );
    }
}

export class FinishPartialProgressStrategy implements PartialProgressStrategy {
    public isValid(progress: PartialDownloadProgress): boolean {
        return 100 === progress.progress;
    }

    public onProgress(progress: PartialDownloadProgress): void {
        try {
            eventDispatcher.removeHandler('PauseDownloadManager');
            eventDispatcher.removeHandler('ResumeDownloadManager');
            eventDispatcher.removeHandler('CancelDownloadManager');
        } catch (error) {
            console.warn('Error after progress = 100 and no remaining bytes', error);
        }
    }
}